// ColorPicker component
import React from "react";
import { SketchPicker } from "react-color";

const ColorPicker = ({ value, onChange, label = "Color" }) => { // Added label prop with a default value
  return (
    <div className="form-group ">
      <label className="block text-sm font-medium text-gray-700 mb-1" style={{ fontFamily: 'Inter,Source Sans Pro, Helvetica, Arial, sans-serif' }}>{label}</label> {/* Displaying the label */}
      <SketchPicker
        className="mt-1"
        color={value || '#ffffff'}
        onChangeComplete={(color) => onChange(color.hex)}
      />
    </div>
  );
};

export default ColorPicker;